/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

export default class PermitVenueDates extends React.Component {
    static propTypes = {
        permit: PropTypes.object /*HuntingPermitType*/,
    };

    static defaultProps = {
        permit: {},
    };

    renderHeader() {
        return (
            <thead>
                <tr>
                    <th>Dates</th>
                    <th>Information</th>
                </tr>
            </thead>
        );
    }

    renderRow(importantDate) {
        const {
            description,
            view_order: viewOrder,
            display_order: displayOrder,
            start_date: startDate,
            end_date: endDate,
        } = importantDate;

        const dateDisplayStr = !isEmpty(endDate)
            ? `${startDate} - ${endDate}`
            : `${startDate}`;
        const key = viewOrder || displayOrder || `${Math.random()}`;

        return (
            <tr key={key}>
                <td>{dateDisplayStr}</td>
                <td>{description}</td>
            </tr>
        );
    }

    render() {
        const importantDates = get(this.props.permit, 'important_dates', []);
        if (!importantDates.length) return null;

        return (
            <div id="important-dates">
                <h2 className="h5-normal mt-4 mb-2">Important Dates</h2>
                <table>
                    {this.renderHeader()}
                    <tbody>
                        {importantDates.map((d) => {
                            return this.renderRow(d);
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}
